import Input, { InputWithMenu } from './Input';

export default Input;
export { InputWithMenu };
